import { RequestException } from './exceptions';
export default class RequestExceptionWithResponse extends RequestException {
    constructor(response, errorResponse) {
        super(response);
        this.code = errorResponse.code;
        this.rcid = errorResponse.requestCorrelationId ? errorResponse.requestCorrelationId.value : undefined;
        this.errorName = errorResponse.name;
        this.developerMessage = errorResponse.developerMessage;
        this.type = errorResponse.type;
        this.message = errorResponse.message;
    }
}
/**
 RequestExceptionWithResponse {
    name: 'RequestExceptionWithResponse',
    status: 400,
    url: '/test',
    code: 'INF4570001',
    rcid: '1234-1234-1234-12345',
    errorName: 'MANGLER_BANKREGNR',
    developerMessage: 'stacktrace fra java',
    type: 'BAD_REQUEST'
 }
 */
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdEV4Y2VwdGlvbldpdGhSZXNwb25zZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3JlcXVlc3Qvc3JjL3JlcXVlc3RFeGNlcHRpb25XaXRoUmVzcG9uc2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFpQixnQkFBZ0IsRUFBRSxNQUFNLGNBQWMsQ0FBQztBQUUvRCxNQUFNLENBQUMsT0FBTyxPQUFPLDRCQUE2QixTQUFRLGdCQUFnQjtJQUN0RSxZQUFZLFFBQWtCLEVBQUUsYUFBNEI7UUFDeEQsS0FBSyxDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBRWhCLElBQUksQ0FBQyxJQUFJLEdBQUcsYUFBYSxDQUFDLElBQUksQ0FBQztRQUMvQixJQUFJLENBQUMsSUFBSSxHQUFHLGFBQWEsQ0FBQyxvQkFBb0IsQ0FBQyxDQUFDLENBQUMsYUFBYSxDQUFDLG9CQUFvQixDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDO1FBQ3RHLElBQUksQ0FBQyxTQUFTLEdBQUcsYUFBYSxDQUFDLElBQUksQ0FBQztRQUNwQyxJQUFJLENBQUMsZ0JBQWdCLEdBQUcsYUFBYSxDQUFDLGdCQUFnQixDQUFDO1FBQ3ZELElBQUksQ0FBQyxJQUFJLEdBQUcsYUFBYSxDQUFDLElBQUksQ0FBQztRQUMvQixJQUFJLENBQUMsT0FBTyxHQUFHLGFBQWEsQ0FBQyxPQUFPLENBQUM7SUFDekMsQ0FBQztDQUNKO0FBRUQ7Ozs7Ozs7Ozs7O0dBV0cifQ==